console.log('Sistema e Gestão por Companhia de Estágios');
